import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "tabs is-toggle is-small mb-3" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "tabs is-boxed is-small mb-4" };
const _hoisted_4 = { class: "is-active" };
const _hoisted_5 = { style: { "cursor": "default" } };
const _hoisted_6 = { class: "columns pl-4 pr-4 mb-4" };
const _hoisted_7 = ["checked", "onChange"];
import { onMounted, ref } from "vue";
import { UserNotificationEventTypes } from "./model";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserNotificationPreferencesEditor',
    props: {
        modelValue: {}
    },
    emits: ['update:modelValue'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const subscribedEvents = ref(new Set());
        const mode = ref("all");
        // We don't want to mess with any event types the user is subscribed to which our code does not recognise.
        // So we'll just save them here, and preserve them whenever we modify the set of subscriptions
        const unknownSubscribedEvents = [];
        // Event for two-way binding
        const emit = __emit;
        onMounted(() => {
            for (let subscribedEvent of props.modelValue.subscribedEvents) {
                if (subscribedEvent == '*' || allKnownEventTypes.includes(subscribedEvent)) {
                    subscribedEvents.value.add(subscribedEvent);
                }
                else {
                    unknownSubscribedEvents.push(subscribedEvent);
                }
            }
            if (subscribedEvents.value.has("*")) {
                mode.value = "all";
            }
            else if (subscribedEvents.value.size == 0) {
                mode.value = "none";
            }
            else {
                mode.value = "custom";
            }
        });
        const changeMode = (m) => {
            console.log(m);
            switch (m) {
                case "all":
                    console.log("emitall");
                    emit('update:modelValue', { "subscribedEvents": ["*", ...unknownSubscribedEvents] });
                    break;
                case "none":
                    emit('update:modelValue', { "subscribedEvents": [...unknownSubscribedEvents] });
                    break;
                case "custom": {
                    subscribedEvents.value.clear();
                    if (mode.value == "all") {
                        for (let knownEvent of allKnownEventTypes) {
                            subscribedEvents.value.add(knownEvent);
                        }
                    }
                    emit('update:modelValue', { "subscribedEvents": [...Array.from(subscribedEvents.value), ...unknownSubscribedEvents] });
                    break;
                }
            }
            mode.value = m;
        };
        const toggleSubscription = (event) => {
            if (subscribedEvents.value.has(event)) {
                subscribedEvents.value.delete(event);
            }
            else {
                subscribedEvents.value.add(event);
            }
            emit('update:modelValue', { "subscribedEvents": [...Array.from(subscribedEvents.value), ...unknownSubscribedEvents] });
        };
        const allKnownEventTypes = [];
        for (let category of Object.values(UserNotificationEventTypes)) {
            for (let key in category) {
                allKnownEventTypes.push(key);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("ul", null, [
                        _createElementVNode("li", {
                            class: _normalizeClass({ 'is-active': mode.value == 'all' })
                        }, [
                            _createElementVNode("a", {
                                onClick: _cache[0] || (_cache[0] = ($event) => (changeMode('all')))
                            }, "All")
                        ], 2),
                        _createElementVNode("li", {
                            class: _normalizeClass({ 'is-active': mode.value == 'none' })
                        }, [
                            _createElementVNode("a", {
                                onClick: _cache[1] || (_cache[1] = ($event) => (changeMode('none')))
                            }, "None")
                        ], 2),
                        _createElementVNode("li", {
                            class: _normalizeClass({ 'is-active': mode.value == 'custom' })
                        }, [
                            _createElementVNode("a", {
                                onClick: _cache[2] || (_cache[2] = ($event) => (changeMode('custom')))
                            }, "Custom")
                        ], 2)
                    ])
                ]),
                (mode.value == 'custom')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(UserNotificationEventTypes), (events, category) => {
                            return (_openBlock(), _createElementBlock("div", { key: category }, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("ul", null, [
                                        _createElementVNode("li", _hoisted_4, [
                                            _createElementVNode("a", _hoisted_5, [
                                                _createElementVNode("strong", null, _toDisplayString(category), 1)
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events, (label, event) => {
                                        return (_openBlock(), _createElementBlock("label", {
                                            key: event,
                                            class: "column checkbox"
                                        }, [
                                            _createElementVNode("input", {
                                                type: "checkbox",
                                                class: "mr-3",
                                                checked: subscribedEvents.value.has(event),
                                                onChange: ($event) => (toggleSubscription(event))
                                            }, null, 40, _hoisted_7),
                                            _createTextVNode(" " + _toDisplayString(label), 1)
                                        ]));
                                    }), 128))
                                ])
                            ]));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
